import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { motion } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(motion.section) ``;
const List = styled(motion.ul) `
  margin: 0 0 24px;
  overflow: hidden;

  @media ${from(Device.Tablet)} {
    height: auto !important;
  }
`;
const Item = styled.li `
  display: block;
  margin: 0;
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  ${fonts.gillSans.light};
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  text-decoration: none;
  text-underline-position: under;
  transform: translateX(0px);
  transition: transform 0.15s ease-out;

  &:focus,
  &:hover {
    outline: none;
    text-decoration: underline;
  }

  @media ${from(Device.Tablet)} {
    text-align: left;

    &:focus,
    &:hover {
      transform: translateX(4px);
    }
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 16px;
    line-height: 28px;
  }
`;
export default {
    Container,
    Item,
    Link,
    List,
};
